import { db } from "./firebase";

import {
    doc,
    setDoc,
    onSnapshot,
    serverTimestamp,
} from "firebase/firestore";

const COLLECTION = "csc_cart";

/* ---------------------------------- */
/* SLOT ID HELPER */
/* ---------------------------------- */

export const createSlotId = (
    courtId,
    date,
    startHour
) => {

    const hours =
        Math.floor(startHour);

    const minutes =
        Math.round(
            (startHour - hours) * 60
        );

    const paddedHours =
        String(hours)
            .padStart(2, "0");

    const paddedMinutes =
        String(minutes)
            .padStart(2, "0");

    return (
        `${courtId}_${date}_${paddedHours}-${paddedMinutes}`
    );
};

/* ---------------------------------- */
/* PREPARE CART ITEMS */
/* ---------------------------------- */

const prepareCartItems = (
    items = []
) => {

    return items.map((item) => ({

        ...item,

        /* DETERMINISTIC SLOT ID */

        slotId:

            item.slotId ||

            createSlotId(

                item.courtId,

                item.date,

                item.startHour
            ),
    }));
};

/* ---------------------------------- */
/* SAVE CART */
/* ---------------------------------- */

export const saveCartToDB = async (

    userId,

    items

) => {

    const preparedItems =
        prepareCartItems(items);

    await setDoc(

        doc(
            db,
            COLLECTION,
            userId
        ),

        {

            items:
                preparedItems,

            updatedAt:
                serverTimestamp(),
        },

        {
            merge: true,
        }
    );
};

/* ---------------------------------- */
/* REALTIME CART LISTENER */
/* ---------------------------------- */

export const subscribeToCart = (

    userId,

    callback

) => {

    return onSnapshot(

        doc(
            db,
            COLLECTION,
            userId
        ),

        (snapshot) => {

            if (
                snapshot.exists()
            ) {

                const data =
                    snapshot.data();

                const preparedItems =
                    prepareCartItems(
                        data.items || []
                    );

                callback(
                    preparedItems
                );

            } else {

                callback([]);
            }
        },

        (error) => {

            console.error(

                "Cart listener failed:",

                error
            );

            callback([]);
        }
    );
};